import React from 'react';
import Chip from '@material-ui/core/Chip';
import { RxOrderStatusEnum } from 'openapi';
import { useTranslation } from 'react-i18next';

interface Props {
    status: string | undefined,
    orderId?: number,
    handleStatus?: (orderId: number) => void,
}

export default ((props) => {
    const { t } = useTranslation();

    if (props.status === undefined) {
        return <></>;
    }

    var style = { backgroundColor: 'grey', color: 'white', label: t('waiting') };

    switch (props.status) {
        case RxOrderStatusEnum.Success:
            style = { backgroundColor: '#4caf50', color: 'white', label: t('success') };
            break;
        case RxOrderStatusEnum.Requesting:
            style = { backgroundColor: '#ffeb3b', color: 'black', label: t('requesting') };
            break;
        case RxOrderStatusEnum.Error:
            style = { backgroundColor: '#f44336', color: 'white', label: t('error') };
            break;
        case RxOrderStatusEnum.EmailSent:
            style = { backgroundColor: '#44abe3', color: 'white', label: t('emailSent') };
            break;
        case RxOrderStatusEnum.WaitingResponse:
            style = { backgroundColor: '#7877bd', color: 'white', label: t('waitingResponse') };
            break;
        case RxOrderStatusEnum.InProgress:
            style = { backgroundColor: '#b86780', color: 'white', label: t('inProgress') };
            break;
        case RxOrderStatusEnum.Dispatched:
            style = { backgroundColor: '#e0a846', color: 'white', label: t('dispatched') };
            break;
    }

    return (
        <Chip
            size="small"
            style={{ color: style.color, backgroundColor: style.backgroundColor }}
            label={style.label}
            onClick={() => props.handleStatus && props.status !== RxOrderStatusEnum.Waiting ? props.handleStatus(props.orderId ? props.orderId : -1) : undefined} />)
}) as React.FC<Props>